import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AwsService } from '../../../providers/appsyncservice/aws.service';
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-trip-mst',
  templateUrl: './trip-mst.component.html',
  styleUrls: ['./trip-mst.component.css']
})
export class TripMstComponent implements OnInit {


  tripsList: any = []
  viewList: any = []
  display = 'none'; //default Variable
  checkedAll: boolean = false;
  selectall: boolean = false;
  cabs: any = [];
  scheduled_date: String = '';
  driver_id: String = '';
  disbaleUpdate: boolean = false;
  typeList: any = [];
  statusList: any = [];
  tripForm: FormGroup;
  tripmstsearchfm: FormGroup;
  submitted: boolean = false;
  errorMessage: string;
  errorType: boolean = false;
  id: String = "";
  vhclMstLt: any[];
  vhclMst: any;
  editvehicle: any;
  displayValue: Number = 0;
  cabmaster: any;
  driverusers: any;
  driverDropdownSettings = {};
  name : String;
  driverSelectedItems: any[] = [this.id, this.name];
  nextToken: String = "";

  key: string = 'scheduled_date'; //set default
  reverse: boolean = false;


  geofence_limit: Number;
  positionHome: any;
  positionOffcie: any;
  user_Home_Address: string;
  user_ipin: string;
  user_name: string;
  user_Office_Address: any;
  vehicle_model: string;
  vehicle_no: string;
  buttonval: number = 1;

  managerEmp: any;
  buttonValue: String
  tempEditData: any = {};
  lat: number = 12.7369761;
  lng: number = 80.0066669;

  homelat: number = 12.73377;
  homelong: number = 80.011268;
  officelat: number = 12.73377;
  officelong: number = 80.011268;
  homeAddress: String = "-";
  officeAddress: String = "RNTBCI";
  next: String = '';

  homeMarker = {};
  officeMarker = {};
  markers = [];
  centerPosition = { "lat": 12.73377, "lng": 80.011268 }

  constructor(public awserviceProvider: AwsService,
    private formBuilder: FormBuilder) {

    this.formInitilization();
    this.tripsList = [];
    this.getAllData();
    // this.awserviceProvider.getScTripMasterAll().then(tripslist => {
    //   var trips = tripslist.items;
    //   this.buttonval = trips.length > 15 ? 1 : 0;
    //   trips.forEach(trip => {
    //     this.awserviceProvider.getRncUsers(trip.driver_id).then(driver => {
    //       trip.driver = {};
    //       trip.driver = driver;
    //     });
    //     this.awserviceProvider.getScCabMasterById(trip.cab_id).then(cab => {
    //       trip.cab = {};
    //       trip.cab = cab;
    //     });
    //     this.tripsList.push(trip);

    //   });

    // }).catch(err => {
    //   console.log('err', err)
    // })


    //get Driver List
    this.awserviceProvider.getRncUsersByType(2).then(driverusers => {
      console.log("driverusers", driverusers);
      this.driverusers = driverusers;
    });

    //get Cab List
    this.awserviceProvider.getScCabMasterAll().then(cabs => {
      console.log("driverusers", cabs);
      this.cabs=cabs;
      // var cabslist: any = []
      // cabslist = cabs;
      // console.log(cabslist, "cabslist")
      // cabslist.forEach(cab => {
      //   this.awserviceProvider.getRncUsers(cab.driver_id).then(driver => {
      //     cab.driver = {};
      //     cab.driver = driver;
      //     this.cabs.push(cab)
      //   });

      // });

    });

    // this.awserviceProvider.getEmployeeUser().then(result => {
    //   this.managerEmp = result;
    // });

  }

  getAllData() {
  //  this.tripsList = [];
    console.log("TTT", this.driverSelectedItems)
    console.log("TTT", this.vehicle_no)
    console.log("TTT", this.scheduled_date)
    let vehicle_no=this.vehicle_no!=""?this.driverSelectedItems[0].id:this.vehicle_no;
    console.log("TTT", vehicle_no)
    this.awserviceProvider.getScTripMasterFilterNextToken(vehicle_no, this.scheduled_date,this.nextToken).then(res => {

      if (res.nextToken != null) {
        this.nextToken = res.nextToken;        
        console.log("this.nextToken", this.nextToken)
        this.getAllData();
      }else
      {
        this.nextToken="";
      }


      console.log("tripslist", res)
      var trips = res.items;
      this.buttonval = trips.length > 15 ? 1 : 0;


      trips.forEach(trip => {
        this.awserviceProvider.getRncUsers(trip.driver_id).then(driver => {
          trip.driver = {};
          trip.driver = driver;
        });
        this.awserviceProvider.getScCabMasterById(trip.cab_id).then(cab => {
          trip.cab = {};
          trip.cab = cab;
        });
        this.tripsList.push(trip);

      });
      this.sortinglist();

    }).catch(err => {
      console.log('err', err)
    })
  }

  ngOnInit() {
    this.statusList = [
      {
        id: 0, name: "Not Started"
      },
      {
        id: 1, name: "Started"
      },
      {
        id: 2, name: "Completed"
      }
    ];
    this.typeList = [
      {
        id: 0, name: "Pickup"
      },
      {
        id: 1, name: "Drop"
      }
    ]
    // this.editvehicle={};
    this.buttonValue = "";
    this.displayValue = 0;
    this.driver_id = "";
    this.vehicle_no = "";
    this.scheduled_date = "";
    this.user_ipin = "";
    this.vhclMstLt = [];
    this.driverusers = [];
    this.cabs = [];
    this.driverDropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'vehicle_no',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };



    this.formInitilization();

  }

  formInitilization() {
    this.tripForm = new FormGroup({
      id: new FormControl(""),
      cab_id: new FormControl('', Validators.required),
      scheduled_date: new FormControl('', Validators.required),
      scheduled_time: new FormControl('', Validators.required),
      trip_type: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required)

    });
    // this.tripmstsearchfm = new FormGroup({

    //   scheduled_date: new FormControl(""),
    //   vehicle_no: new FormControl("")
    // });

    // this.triptripmstsearchfmForm.patchValue({
    //   scheduled_date: '2018-11-28'
    // });
    let dateFormat = require('dateformat');
    this.scheduled_date = dateFormat(new Date(), "yyyy-mm-dd")
    this.vehicle_no = '';
    this.driverSelectedItems = [];

  }

  reset() {

    this.formInitilization();
  }

  get f() { return this.tripForm.controls; }

  onSubmit() {
    // alert(this.tripForm.invalid)
    this.submitted = true;

    if (this.tripForm.invalid) {
      return;
    }
    this.disbaleUpdate = true;

    let driverid = this.cabs.filter(cabid => { return cabid.id == this.tripForm.get("cab_id").value });
    this.tripForm.patchValue({
      driver_id: driverid[0].driver_id,
    });
    console.log("SchduledDate", this.tripForm.get("scheduled_date").value)


    this.awserviceProvider.UpdateScTripMaster(this.tripForm.value).then(res => {
      // this.vhclMstLt.unshift(this.tripForm.value);

      this.displayValue = 0;
      this.updateUserTrip(this.tripForm.value);
      //  this.getAllData();
      this.tripsList = [];
      this.getAllData();

    }).catch(err => {
      this.errorType = true;
      console.log(err);
      // alert("update failed");
      this.errorMessage = "Unable to add the data. Please contact system administrator"
    });

  }

  updateUserTrip(form) {

    this.awserviceProvider.getScUserTripByTripId(this.tripForm.get("id").value).then(trips => {
      let usertrips: any = trips;
      usertrips.forEach(usertrip => {
        this.awserviceProvider.UpdateScUserByTrip(usertrip.id, form).then(res => {
        }).catch(err => {
          console.log(err);
        });
      });


    }).catch(err => {
      console.log(err);
    })



  }




  search(searchData) {
    this.tripsList = [];
    this.getAllData();

  }


  editData(tripData: any) {
    // this.buttonValue = "Update";
    console.log("tripData", tripData)
    this.displayValue = 1;
    this.disbaleUpdate = false;
    this.id = tripData.id;
    let dateFormat = require('dateformat');
    let schduled = new Date(tripData.scheduled_date);

    this.tripForm.setValue(
      {
        id: tripData.id,
        cab_id: tripData.cab_id,
        scheduled_date: dateFormat(schduled, "yyyy-mm-dd"),
        scheduled_time: dateFormat(schduled, "HH:MM"),
        trip_type: tripData.trip_type,
        status: tripData.status

      });

    console.log("  this.editvehicle", this.editvehicle)

  }

deleteData(id) {

    this.awserviceProvider.deleteScTripMaster(id).then(res => {
      console.log("tripid", id)
      this.awserviceProvider.getScUserTripId(id).then(result => {
        let usertrips: any = result;
        console.log("usertrips", result)
        usertrips.forEach(usertrip => {
          this.awserviceProvider.deleteScUserTrip(usertrip.id).then(res => {
            console.log("deletedID",id)
          }).catch(err => {
            console.log(err);
          });

        });

      })
    
    }).catch(err => {
      console.log(err);
    });



  }

  add() {

    this.formInitilization();

    this.buttonValue = "Save";
    this.displayValue = 1;

  }

  exportToExcel() {
    let exportJsonTemp = [];

    exportJsonTemp = this.exportJsonFormation(this.tripsList);
    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

    // console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'Trips.xlsx');


  }

  exportToPdf() {
    console.log("exportToPdf")
    //this.spinnerService.show();
    var getColumns = [
      { title: "Driver ID", dataKey: "driver_id" },
      { title: "Driver Name", dataKey: "driver" },
      { title: "Vehicle No", dataKey: "cab" },
      { title: "Schdelued Date", dataKey: "scheduled_date" },
      { title: "Trip Type", dataKey: "trip_type" },
      { title: "Status", dataKey: "status" }
    ];

    var pdfsize = 'a4';
    var doc = new jsPDF('l', 'pt', pdfsize);

    doc.text(20, 20, 'SAFEcab Trips');
    let exportJsonTemp = [];
    exportJsonTemp = this.exportJsonFormation(this.tripsList);
    doc.autoTable(getColumns, exportJsonTemp, {
      startY: 40,
      // startX: 20,
      tableLineColor: [189, 195, 199],
      tableLineWidth: 0.75,
      styles: {
        font: 'Times New Roman',
        fillColor: [217, 217, 217],
        lineColor: [189, 195, 199],
        lineWidth: 0.25,
        textColor: 0,
      },
      headerStyles: {
        fillColor: [217, 217, 217],
        textColor: 0,
      }

    })
    doc.save("SAFEcab Trips.pdf");
  }

  exportJsonFormation(trips) {
    let dateFormat = require('dateformat');
    let exportJsonTemp = [];

    trips.forEach(trip => {
      let exJson: any = {};
     // exJson.id = trip.id;
      exJson.driver_id = trip.driver != null ? trip.driver.user_name : '';
      exJson.driver = trip.driver != null ? trip.driver.name : ''
      exJson.cab = trip.cab != null ? trip.cab.vehicle_no : '';
      exJson.scheduled_date = dateFormat(trip.scheduled_date, "yyyy-mm-dd HH:MM:ss");//new Date(trip.scheduled_date).toLocaleString();
      exJson.trip_type = trip.trip_type == 0 ? 'Pick Up' : 'Drop';
      exJson.status = trip.status == 0 ? 'Not Started' : trip.status == 1 ? 'Started' : 'Completed';
      exportJsonTemp.push(exJson);
    });

    return exportJsonTemp;

  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  sortinglist() {
    const sorted = this.tripsList.sort((t1, t2) => {
      const date1 = t1.scheduled_date;
      const date2 = t2.scheduled_date;
      var start = new Date(date1).getTime();
      var end = new Date(date2).getTime();

      if (start > end) { return -1; }
      if (start < end) { return 1; }
      return 0;
    });

    this.tripsList = sorted;

  }


  //select All locked users
  selectAll() {

    this.tripsList.forEach(trip => {
      if (this.checkedAll == true) { trip.checked = true; this.selectall = true; }
      else { trip.checked = false; this.selectall = false; }
    });
  }


  deletedSelected() {
     let selected = this.tripsList.filter(trip => trip.checked == true);
     console.log("selected",selected.length)
    if (this.selectall == false && selected.length==0) {
      console.log("return")
      return;
    }

    console.log("selected",selected)
     selected.forEach(elm => {
      this.deleteData(elm.id);
    });

  //  this.getAllData();
  
  }


  openModalDialog(id) {
   
     this.viewUserTri(id);
     this.display = 'block'; //Set block css
  }

  closeModalDialog() {
    this.display = 'none'; //set none css after close dialog
  }

  viewUserTri(id){
    this.viewList=[];
    this.awserviceProvider.getScUserTipByTripId(id).then((res: any) => {


      var trips: any = res;
      console.log("trips",trips)
      trips.forEach(trip => {
        this.awserviceProvider.getRncUsers(trip.user_id).then(user => {
          trip.user = {};
          trip.user = user;
        });
        this.viewList.push(trip);
      });

    }).catch(err => {
      console.log('err', err)
    })
  }

  onItemSelect(event) {
    //console.log("event", event)

  }

  onSelectAll(event) {
    //console.log("multiselect")
  }



}
